import { motion, useInView } from "motion/react"
import { useRef } from "react"

import { cn } from "@/ui/utils"

import demoLanding from "./assets/demo-1.png"
import demoLogin from "./assets/demo-2.png"
import demoStorybook from "./assets/demo-3.png"

type DemoSlide = {
  src: string
  alt: string
  frameClass: string
  objectPosition?: string
}

const demos: DemoSlide[] = [
  {
    src: demoLanding,
    alt: "PageZERO marketing landing page in the browser",
    frameClass: "md:-left-1 md:top-8 md:z-20 md:w-3/5",
  },
  {
    src: demoLogin,
    alt: "Authentication login screen",
    frameClass: "md:-right-2 md:top-0 md:z-30 md:w-1/2",
  },
  {
    src: demoStorybook,
    alt: "Storybook component documentation",
    frameClass: "md:-bottom-8 md:right-10 md:z-30 md:w-2/5",
  },
]

const enter = { opacity: 0, y: 24 }
const visible = { opacity: 1, y: 0 }

export function DemoShowcase() {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: true, margin: "-100px" })

  return (
    <div ref={ref} className="relative mx-auto max-w-6xl">
      <div className="pointer-events-none absolute inset-0 -mx-5 overflow-x-clip" aria-hidden>
        <div className="bg-primary/8 dark:bg-primary/12 absolute left-1/4 size-72 rounded-full blur-3xl" />
        <div className="bg-chart-2/10 dark:bg-chart-2/16 absolute -top-1/5 right-16 size-64 rounded-full blur-3xl" />
      </div>

      <div className="relative flex flex-col gap-10 md:block md:h-136">
        {demos.map((demo, i) => (
          <motion.img
            key={demo.alt}
            src={demo.src}
            alt={demo.alt}
            loading="lazy"
            decoding="async"
            className={cn(
              "rounded border-4 shadow-2xl md:absolute md:rounded-2xl",
              demo.frameClass,
            )}
            initial={enter}
            animate={isInView ? visible : enter}
            transition={{
              duration: 1,
              delay: 0.2 * i,
              ease: [0.22, 1, 0.36, 1],
            }}
            whileHover={{
              scale: 1.1,
              zIndex: 50,
              transition: { duration: 0.2 },
            }}
          />
        ))}
      </div>
    </div>
  )
}
